import { AccordionType } from './type';
import { Accordion } from '@jd/platform-config';
import { DeepNullToUndefined } from '@jd/client/utils/unnulable';
import { parseSxConfig } from '@jd/client/utils/sxParser';
import { sectionTitleMapper } from '../../../utils/mappers/sectionTitleMapper';
import { iconMapper } from '../../elements/TbIcon/mapper';

type Input = DeepNullToUndefined<Accordion>;

const variantMap = {
  fullPageVertical: 'fullVertical',
  fullPageHorizontal: 'fullHorizontal',
  standard: 'standard',
} as const;

type AccordionDefaults = {
  isDark?: 'light' | 'dark' | null;
  isOpenDark?: 'light' | 'dark' | null;
};

export const accordionMapper = (
  input: Input,
  defaults?: AccordionDefaults,
): AccordionType => {
  const isDarkOverride = input.styling?.isDark;
  const isDark =
    isDarkOverride === 'dark'
      ? true
      : isDarkOverride === 'light'
        ? false
        : defaults?.isDark === 'dark'
          ? true
          : defaults?.isDark === 'light'
            ? false
            : undefined;

  const isOpenDarkOverride = input.styling?.isOpenDark;
  const isOpenDark =
    isOpenDarkOverride === 'dark'
      ? true
      : isOpenDarkOverride === 'light'
        ? false
        : defaults?.isOpenDark === 'dark'
          ? true
          : defaults?.isOpenDark === 'light'
            ? false
            : undefined;

  return {
    variant: variantMap[input.content.variant] ?? 'standard',
    icon: iconMapper(input.content.icon),
    elements: input.content.elements ?? [],
    titles: sectionTitleMapper(input.sectionTitle, input.styling?.titlesStyle),
    styling: {
      sx: parseSxConfig(input.styling?.sx),
      isDark,
      isOpenDark,
    },
    seo: {
      schemaType: input.seo?.schemaType,
      seoDescriptionOverride: input.seo?.seoDescriptionOverride,
      schemaId: input.seo?.schemaId,
    },
  };
};
